import { render, staticRenderFns } from "./BorrowSuccess.vue?vue&type=template&id=c761a6b6"
import script from "./BorrowSuccess.vue?vue&type=script&lang=js"
export * from "./BorrowSuccess.vue?vue&type=script&lang=js"
import style0 from "./BorrowSuccess.vue?vue&type=style&index=0&id=c761a6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports